import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import lockIcon from "../../medias/lockIcon.svg";
import logo from '../../medias/logoAlpha.png';
import userIcon from "../../medias/userIcon.svg";
import { Container, Link } from "@mui/material";
import { CriticalError } from "../CriticalError";
import {
    Group,
    InputButton,
    InputField,
    showSimpleSnackbarDispatcher,
    showSnackbar,
} from "../../components/";
import { Page } from "../Page";
import { apiClient } from "../../api/";
import { styles } from "../../theme/";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "../../hooks/";
import { useState } from "react";

/**
 * SignIn page
 */
export const SignIn = () => {
    // Hooks
    const SearchParams = useSearchParams();
    const navigate = useNavigate();

    // useStates
    const [criticalError, setCriticalError] = useState<boolean>(false);
    const [email, setEmail] = useState<string>("");
    const [error, setError] = useState<boolean>(false);
    const [password, setPassword] = useState<string>("");

    const to = SearchParams.get("to");

    // Handlers
    const handleSignIn = async () => {
        try {
            const [signInResponse, signInStatusOk] = await apiClient.signIn(email.toLocaleLowerCase(), password);

            if (signInStatusOk && signInResponse.token) {
                const token = signInResponse.token;

                showSnackbar({ message: `Welcome, ${email}.`, variant: "success" });
                localStorage.setItem("token", token);

                const [getUserResponse, getUserStatusOk] = await apiClient.getUser(token);

                if (getUserStatusOk) {
                    const {
                        verified,
                        profiles,
                    } = getUserResponse;

                    if (!verified) navigate("/needsEmailVerification");
                    else if (!profiles || !(profiles.length > 0)) navigate("/createProfile");
                    else navigate(to ?? "/games");

                } else {
                    setError(true);
                    showSimpleSnackbarDispatcher(getUserResponse as { [key: string]: string[]; });
                }
            } else {
                setError(true);
                showSimpleSnackbarDispatcher(signInResponse as { [key: string]: string[]; });
            }
        } catch (error) {
            setCriticalError(true);
            showSnackbar({ message: String(error), variant: "error" });
        }
    };

    // Early return
    if (criticalError) return <CriticalError />;

    return (
        <Page >
            <Container style={styles.inPlaceModal} >
                <div style={{
                    marginBottom: -60,
                    marginLeft: -70,
                    marginTop: -25,
                    width: "100%",
                }}>
                    <InputButton
                        onClick={() => navigate("/games")}
                        tooltip={`Go to games`}
                        type="main"
                        style={{
                            borderRadius: "50%",
                            height: "60px",
                            minWidth: 0,
                            padding: 0,
                            width: "60px",
                        }}
                    >
                        <ArrowBackIcon />
                    </InputButton>
                </div>
                <img src={logo} style={{ width: 380 }} alt="OP Club" />
                <InputField type="email" value={email} leftIcon={userIcon} placeholder={"Email"} error={error} setValue={setEmail} />
                <InputField type="password" value={password} leftIcon={lockIcon} leftIconSize="100%" placeholder={"Password"} error={error} setValue={setPassword} submitAction={() => handleSignIn()} />
                <div style={{ display: "flex", width: "100%", justifyContent: "flex-end", marginTop: -20 }}>
                    <Link component="button" underline="hover" style={styles.link} onClick={() => { navigate("/resetPassword"); }}>Forgot your password?</Link>
                </div>
                <Group direction="row">
                    <InputButton type="secondary" onClick={() => navigate(to ? `/signUp?to=${to}` : "/signUp")} tooltip="Create an account">Sign up</InputButton>
                    <InputButton type="primary" onClick={() => handleSignIn()} disabled={!email || !password} tooltip="Access">Sign in</InputButton>
                </Group>
            </Container>
        </Page>
    );
};